// src/app/global-error-handler.ts
import { ErrorHandler, Injectable } from '@angular/core';
import { TelemetryService } from './telemetry.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private telemetry: TelemetryService) {}
  handleError(error: any): void {
    this.telemetry.trackException(error);
    console.error(error);
  }
}